import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-tai-chi': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_male_chair_tai_chi_glucose~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_male_chair_tai_chi_glucose'),
			},
			funnel: {
				id: 'ob-male-tai-chi-chair-workouts-glucose',
				locale: ['en'],
			},
		},
	},
]

export default config
